import type { ReactNode } from 'react'

export interface SelectableCardProps {
  className?: string
  state?: SelectableCardStateType
  disposition?: SelectableCardDispositionType
  disabled?: boolean
  children?: ReactNode
  showActionIndicator?: boolean
}

export enum SelectableCardState {
  selected = 'selected',
  unselected = 'unselected',
  indeterminate = 'indeterminate',
}

export enum SelectableCardDisposition {
  horizontal = 'horizontal',
  vertical = 'vertical',
}

export type SelectableCardStateType = `${SelectableCardState}`
export type SelectableCardDispositionType = `${SelectableCardDisposition}`
